import { configureStore } from "@reduxjs/toolkit";
import expenseReducer from "../redux/expenseSlice"; // Ensure this is correctly imported
import userReducer from "../redux/userSlice";
import transactionReducer from "../redux/transactionSlice"
const store = configureStore({
  reducer: {
    expense: expenseReducer, 
    user:userReducer,
    transactions:transactionReducer,
  },
});

export default store;
